import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
    copyRightYear: string = "";

    constructor() {
        this.copyRightYear = (new Date().getFullYear()).toString();

        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};
        if (browserWindowEnv.hasOwnProperty('copyRightYear')) {
            this.copyRightYear = window['__env']['copyRightYear'];
        }
    }

  ngOnInit() { }

}
